import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { car_price_report_template } from "../components/templates/car_price_report_template";
import { downloadCSV } from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";

import { header } from "./header";

declare var ko: any;

export class car_price_report extends vnModule_knockoutJS{

    protected carPriceReportTemplate: car_price_report_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected pagination: pagination_template;
    protected timer;

    protected getModuleName(): string{

        return "car_price_report";
    }

    buildContent(): Array<Element>{

        this.carPriceReportTemplate = new car_price_report_template("list", this.viewModel, this);
        this.template = this.carPriceReportTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Car Price History");

        return [this.carPriceReportTemplate.build()];
    }

    public fillPage() : void{

        this.carPriceReportTemplate.buildDatePickerCalendar();
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterList(): void{

        this.loadingIn(this.carPriceReportTemplate.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/analytics/car-price-report/get/';

        let subViewModel = this.carPriceReportTemplate.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'car_price_report');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.carPriceReportTemplate.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any) {

        this.carPriceReportTemplate.setPriceHistory(responseParsed.data.data);

        let execTime = Math.round((new Date().getTime() - this.timer) / 1000 * 100) / 100;
        this.carPriceReportTemplate.setResultInfo(responseParsed.data.totalCount, responseParsed.data.totalPage, execTime );

        this.viewModel.list.pagination.itemCount(responseParsed.data.totalCount);
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected listReorder(){

        this.filterList();
    }

    protected filterDateOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    public exportToCSV(filters): void{

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.carPriceReportTemplate.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.carPriceReportTemplate.getViewModelForRequest();
        let subViewModelClone = Object.assign({}, subViewModel);
        subViewModelClone.pagination.pageNumber(1);
        subViewModelClone.pagination.itemPerPage = 100000000000;

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/analytics/car-price-report/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModelClone)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onExportRequestReturn;
        this.XHRHdl.execute();
    }

    protected onExportRequestReturn(req, obj){

        return function(){
            if (req.request.readyState == 4) {
                obj.manageResponse(req, obj, function(){
                    let responseParsed = JSON.parse(req.request.response);
                    obj.exportRows(responseParsed.data.data);
                });

                obj.resetExportState();
                obj.loadingOut(obj.carPriceReportTemplate.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    protected exportRows(data: any): void{
        downloadCSV({filename: "carPriceReport.csv", data: data});
    }

    protected resetExportState(): void{
        this.carPriceReportTemplate.getTemplateViewModel().exportInProgress(false);
        this.carPriceReportTemplate.getTemplateViewModel().exportTextBox("Export to CSV");
    }
}



// WEBPACK FOOTER //
// ./js/modules/car_price_report.ts